import Link_module_default from "./Link.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Link/Link.tsx
/**
* A link component.
*/
var Link = forwardRef(function Link({ children, className, kind = "primary", size = "md", ...props }, ref) {
	return /* @__PURE__ */ jsx("a", {
		ref,
		...props,
		rel: "noreferrer noopener",
		className: classNames(Link_module_default.link, className),
		"data-kind": kind,
		"data-size": size,
		children
	});
});
//#endregion
export { Link };

//# sourceMappingURL=Link.js.map